import { CheckCircledIcon, UpdateIcon } from '@radix-ui/react-icons';
import { useCallback, useContext, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router';
import '../App.css';
import { Button } from '../components/ui/button';
import { Form, FormControl, FormDescription, FormField, FormItem, FormLabel, FormMessage } from '../components/ui/form';
import { Input } from '../components/ui/input';
import { Label } from "../components/ui/label";
import { RadioGroup, RadioGroupItem } from "../components/ui/radio-group";
import { Separator } from '../components/ui/separator';
import { Skeleton } from '../components/ui/skeleton';
import { toast } from '../components/ui/use-toast';
import { AuthContext } from '../context/AuthContext';
import api from '../lib/api';

function BunnyInformation() {
    const { auth } = useContext(AuthContext);
    const form = useForm();
    let { bunnyId } = useParams();
    bunnyId = parseInt(bunnyId);
    const [bunny, setBunny] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        name: '',
        breeding_information: '',
    });

    const fetchBunnyInformation = useCallback(() => {
        setIsLoading(true); // Start loading data

        api.get(`https://skhrf-api.cmdigital.se/v1/bunnies?bunnyId=${bunnyId}`)
            .then(response => {
                const bunnyData = response.data;
                setBunny(bunnyData);

                setFormData({
                    name: bunnyData.name || '',
                    breeding_information: bunnyData.breeding_information || '',
                });
                setIsLoading(false); // Data fetched, set loading to false
            })
            .catch(error => {
                console.error('Error fetching bunny information:', error);
                setIsLoading(false); // Error occurred, set loading to false

            });
    }, [bunnyId]);

    const sendBunnyInformation = (e) => {
        if (isLoading) return;
        e.preventDefault();
        setIsLoading(true);

        api.put(`https://skhrf-api.cmdigital.se/v1/bunnies/edit`, {
            bunnyId,
            ...formData,
        }).then(response => {

            setIsLoading(false);
            fetchBunnyInformation();
            toast({
                variant: 'success',
                title: 'Informationen uppdaterades!',
                description: "Informationen uppdaterades utan problem.",
            });
            navigate(`/bunny/${bunnyId}`);
        }).catch(error => {
            console.error('error', error)
            toast({
                variant: 'destructive',
                title: 'Något gick fel.',
                description: error?.response?.data?.error,
            });
            setIsLoading(false);
        });
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    useEffect(() => {
        fetchBunnyInformation();
    }, [fetchBunnyInformation]);

    return (
        <div className='flex w-full items-center justify-center'>
            <div className='flex w-5/6 sm:w-3/4 flex-col py-6 gap-3'>
                <h1 className='font-medium text-2xl mb-2'>
                    {isLoading ? (
                        <Skeleton className='w-64 h-8' />
                    ) : (
                        `Redigera ${bunny.name}s information`
                    )}
                </h1>
                <Form {...form} >
                    <form className="flex flex-col gap-6 w-full sm:w-1/2">
                        <div className="grid grid-cols-1 gap-3">
                            {(auth.user?.superadmin || auth.user?.bunnyadmin) && (
                                <>
                                    <FormField
                                        control={form.control}
                                        name="name"
                                        render={({ field }) => (
                                            <FormItem className="space-y-0 grid gap-2">
                                                <FormLabel>Namn</FormLabel>
                                                <FormControl>
                                                    <Input
                                                        placeholder="Johan"
                                                        name="name"
                                                        value={formData.name}
                                                        onChange={handleChange}
                                                        disabled={isLoading}
                                                        autoComplete='off'
                                                    />
                                                </FormControl>
                                                <FormDescription>Detta fält är endast synligt för förbunds- och kaninadministratörer.</FormDescription>
                                                <FormMessage />
                                                <Separator />
                                            </FormItem>
                                        )}
                                    />
                                    <FormField
                                        control={form.control}
                                        name="breeding_information"
                                        render={({ field }) => (
                                            <FormItem className="space-y-0 grid gap-2">
                                                <FormLabel>Avelsinformation</FormLabel>
                                                <FormControl>
                                                    <Input
                                                        placeholder="Ange avelsinformation här..."
                                                        name="breeding_information"
                                                        value={formData.breeding_information}
                                                        onChange={handleChange}
                                                        disabled={isLoading}
                                                        autoComplete='off'
                                                    />
                                                </FormControl>
                                                <FormDescription>Detta fält är endast synligt för förbunds- och kaninadministratörer.</FormDescription>
                                                <FormMessage />
                                                <Separator />
                                            </FormItem>
                                        )}
                                    />
                                </>
                            )}
                        </div>
                        <Button type="submit" disabled={isLoading} onClick={sendBunnyInformation}>
                            {isLoading ? <UpdateIcon className='loader-spinner' /> : <><CheckCircledIcon className='mr-3' />Uppdatera</>}
                        </Button>
                    </form>
                </Form>
            </div>
        </div>
    );
}

export default BunnyInformation;
